export default __webpack_public_path__ + "static/media/login-visual3.c2f255df.jpg";